<template>
  <k-page class="page-utils-emails">
    <the-utils-emails />
  </k-page>
</template>

<script>
/**
 * Component: page-utils-emails - Страница со списком e-mail подписок
*
* @version 1.0.0
*/


// Components
import KPage from '@/components/KPage.vue';
import TheUtilsEmails from '@/components/TheUtilsEmails.vue';


export default {
  name: 'page-utils-emails',

  components: {
    KPage,
    TheUtilsEmails,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-utils-emails {
  $this: &;
}
</style>
